import { render, staticRenderFns } from "./home.html?vue&type=template&id=53495960&scoped=true&"
import script from "./home.js?vue&type=script&lang=js&"
export * from "./home.js?vue&type=script&lang=js&"
import style0 from "./home.scss?vue&type=style&index=0&id=53495960&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53495960",
  null
  
)

export default component.exports